import React, { useState } from 'react';
import { useData } from '../../store/DataContext';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Select } from '../../components/ui/Select';
import { Input } from '../../components/ui/Input';
import { Download, Printer, FileSpreadsheet } from 'lucide-react';
import { formatCurrency } from './utils';
export const Reports: React.FC = () => {
  const {
    invoices,
    payments
  } = useData();
  const [reportType, setReportType] = useState('revenue');
  const [dateRange, setDateRange] = useState('this-month');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const generateReport = () => {
    // Mock report generation
    alert('Report generation is coming soon.');
  };
  return <div className="space-y-6" data-id="element-1556">
      <div className="flex justify-between items-center" data-id="element-1557">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1558">Reports</h1>
      </div>

      <Card data-id="element-1559">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end" data-id="element-1560">
          <Select label="Report Type" value={reportType} onChange={e => setReportType(e.target.value)} options={[{
          value: 'revenue',
          label: 'Revenue Report'
        }, {
          value: 'outstanding',
          label: 'Outstanding Invoices'
        }, {
          value: 'payments',
          label: 'Payments Received'
        }, {
          value: 'cashier',
          label: 'Cashier Collections'
        }, {
          value: 'department',
          label: 'Department Revenue'
        }]} data-id="element-1561" />
          <Select label="Date Range" value={dateRange} onChange={e => setDateRange(e.target.value)} options={[{
          value: 'today',
          label: 'Today'
        }, {
          value: 'this-week',
          label: 'This Week'
        }, {
          value: 'this-month',
          label: 'This Month'
        }, {
          value: 'this-year',
          label: 'This Year'
        }, {
          value: 'custom',
          label: 'Custom Range'
        }]} data-id="element-1562" />
          {dateRange === 'custom' && <>
              <Input label="Start Date" type="date" value={startDate} onChange={e => setStartDate(e.target.value)} data-id="element-1563" />
              <Input label="End Date" type="date" value={endDate} onChange={e => setEndDate(e.target.value)} data-id="element-1564" />
            </>}
          <div className="flex space-x-2" data-id="element-1565">
            <Button onClick={generateReport} className="w-full" data-id="element-1566">
              Generate
            </Button>
          </div>
        </div>
      </Card>

      <Card noPadding data-id="element-1567">
        <div className="p-12 text-center text-gray-500" data-id="element-1568">
          <FileSpreadsheet className="mx-auto h-12 w-12 text-gray-300 mb-4" data-id="element-1569" />
          <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-1570">
            Select parameters and generate a report
          </h3>
          <p className="text-sm" data-id="element-1571">
            The report data will appear here. You can then export it to PDF or
            CSV.
          </p>
        </div>
      </Card>
    </div>;
};